module.exports = "<div class=\"wrapper\"><div account-settings-side-menu=\"\"></div><div class=\"content\"><router-outlet></router-outlet></div></div>"